import { BreadcrumbItem } from '@mi-front/ui';
import { compact } from 'lodash';
import { useIntl } from 'react-intl';
import { AuditBreadcrumbs } from '../../../components/breadcrumbs/AuditBreadcrumbs';
import {
  createdReportsBreadcrumbItem,
  globalReportsBreadcrumbItem,
  savedReportsTypeBreadcrumbItem,
} from '../../../components/breadcrumbs/breadcrumb-items';

export interface GlobalReportsBreadcrumbsProps {
  items?: readonly BreadcrumbItem[];
  showCreatedReports?: boolean;
  showGlobalReports?: boolean;
  /** When set, appends a crumb to the saved-reports list for that report type. */
  reportType?: string;
}

export function GlobalReportsBreadcrumbs({
  items = [],
  showCreatedReports = false,
  showGlobalReports = false,
  reportType,
}: GlobalReportsBreadcrumbsProps) {
  const { formatMessage } = useIntl();

  const baseItems: BreadcrumbItem[] = compact([
    ...(showGlobalReports ? [globalReportsBreadcrumbItem(formatMessage)] : []),
    ...(showCreatedReports ? [createdReportsBreadcrumbItem(formatMessage)] : []),
    reportType ? savedReportsTypeBreadcrumbItem(formatMessage, reportType) : undefined,
    ...items,
  ]);

  return <AuditBreadcrumbs items={baseItems} />;
}
